<script lang="ts">
  import type { Snippet } from 'svelte';
  import { page } from '@inertiajs/svelte';
  import Navigation from '@/components/Navigation.svelte';
  import Sidebar from '@/components/Sidebar.svelte';
  import ToastViewport from '@/components/ui/ToastViewport.svelte';
  import { auth } from '@/stores/user';

  let { children }: { children?: Snippet } = $props();

  // Inertia shared props → auth store 동기화
  // Rails ApplicationController의 inertia_share가 매 요청마다 auth.user를 제공하지만
  // Svelte store($auth)는 별도로 관리되므로 여기서 연결해줘야 함
  $effect(() => {
    const pageAuth = (page.props as any).auth;
    if (pageAuth?.user) {
      auth.setUser(pageAuth.user, pageAuth.user.organization ?? null);
    } else {
      auth.clearUser();
    }
  });

  // Sidebar 상태를 동기적으로 초기화하여 페이지 전환 시 깜빡임 방지
  function getInitialSidebarState(): boolean {
    if (typeof window === 'undefined') return false;
    const isDesktop = window.innerWidth >= 1024;
    if (!isDesktop) return false;
    const saved = localStorage.getItem('sidebarOpen');
    return saved !== null ? saved === 'true' : true;
  }

  let sidebarOpen = $state(getInitialSidebarState());

  function toggleSidebar() {
    sidebarOpen = !sidebarOpen;
    localStorage.setItem('sidebarOpen', String(sidebarOpen));
  }
</script>

<!-- Skip to content (A11y) -->
<a href="#main-content" class="skip-to-content">
  본문으로 바로가기
</a>

<div class="flex h-screen bg-gray-50 dark:bg-dark-primary">
  <ToastViewport />

  <!-- Sidebar -->
  <Sidebar open={sidebarOpen} onclose={() => (sidebarOpen = false)} />

  <!-- Main Content -->
  <div class="flex flex-1 flex-col overflow-hidden">
    <!-- Top Navigation -->
    <Navigation ontoggleSidebar={toggleSidebar} />

    <!-- Page Content -->
    <main
      id="main-content"
      class="flex-1 overflow-y-auto bg-gray-50 dark:bg-dark-primary"
    >
      <div class="px-4 sm:px-6 lg:px-8 py-6 lg:py-8 max-w-[1600px] mx-auto">
        {@render children?.()}
      </div>

      <!-- Footer -->
      <footer class="border-t border-default px-4 sm:px-6 lg:px-8 py-4">
        <div class="max-w-[1600px] mx-auto flex items-center justify-between text-caption text-gray-400 dark:text-dark-text-disabled">
          <span>© {new Date().getFullYear()} ax_admin</span>
          <div class="flex items-center gap-4">
            <a href="/terms" class="hover:text-primary transition-colors">이용약관</a>
            <a href="/privacy" class="hover:text-primary transition-colors">개인정보처리방침</a>
          </div>
        </div>
      </footer>
    </main>
  </div>
</div>
